var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240812812,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 36771,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.36 904.832a230.336 230.336 0 0 0 206.08-127.168l221.76 39.04v5.888a164.48 164.48 0 1 0 15.488-69.952l-216.384-38.08a229.504 229.504 0 0 0-57.344-195.904l200.128-200.128a164.48 164.48 0 1 0-56.832-36.288L357.632 476.8a230.336 230.336 0 1 0-118.208 427.968z",
    fill: "#46766a",
    "p-id": 36772
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/分子身份证.3e021cf1a754e793bfbfbed5ddc4bb43.svg";
export { ForwardRef as ReactComponent };